<!--
   Created by qing on 2020/11/9
   Des:
-->
<template>

  <div class="mine-container" v-wechat-title="title">
    <div
      class="mine-header"
      v-if="userInfo">
      <van-image
        class="mine-header__user-image"
        width="60px"
        height="60px"
        fit="cover"
        radius="6"
        :src="userInfo.headImg">
      </van-image>
      <div class="mine-header__user-info">
        <div class="user-info__nick-name">{{ userInfo.userName }}</div>
        <div class="user-info__account">{{ actionPhoneSeparated(userInfo.telephone) }}</div>
      </div>
    </div>

    <van-cell title="当前团队" class="company-cell">
      <div class="active-company">
        <div class="van-cell-text">{{ currentCompany ? currentCompany.companyName : '' }}</div>
      </div>
    </van-cell>

    <!--v-if="permission && (permission.creator || permission.topAdmin)"-->
    <van-cell
      v-if="false"
      @click="onClickTeamApply"
      is-link>
      <div slot="title">
        成员申请 <span v-if="applyNum > 0">({{applyNum}})</span>
      </div>
    </van-cell>

    <van-cell
      v-if="false"
      is-link
      @click="onClickTempCenter"
      class="mine-body__company-select">
      <div slot="title">
        应用中心
      </div>
    </van-cell>

    <van-cell
      v-if="!$store.getters.functionConfigMap.hasOwnProperty('sys_showUserOrderCenter') || $store.getters.functionConfigMap.sys_showUserOrderCenter.showFunction"
      is-link
      @click="onClickOrder"
      class="mine-body__company-select">
      <div slot="title">
        我的订单
      </div>
    </van-cell>

    <van-cell
      v-for="item in articleList"
      :key="item.sortIndex"
      is-link
      :title="item.pageTitle"
      @click="onclickArticleItem(item)">
    </van-cell>

    <div class="activity-image-container">

      <div
        class="activity-image-item"
        v-for="item in activityList"
        :key="item.sortIndex">

        <van-image
          class="activity-image"
          width="100%"
          height="50"
          radius="5px"
          fit="cover"
          @click="onclickArticleItem(item)"
          :src="item.imageUrl">
        </van-image>
      </div>
    </div>

    <van-cell
      v-if="$store.getters.env !== ENV_TYPE_LARK_MINI_PROGRAM && $store.getters.openId"
      is-link
      @click="onClickRemoveBinding"
      class="mine-body__company-select">
      <div slot="title">
        解除绑定
      </div>
    </van-cell>

    <van-cell
      v-if="$store.getters.env !== ENV_TYPE_LARK_MINI_PROGRAM"
      is-link
      @click="onClickLogout"
      class="mine-body__company-select">
      <div slot="title">
        退出登录
      </div>
    </van-cell>

    <div class="version">
      Ver：{{version}}
    </div>
  </div>
</template>


<script>
  import {phoneSeparated, setCookie} from "../../../assets/js/Untis";
  import {ENV_TYPE_LARK_MINI_PROGRAM} from "../../store/types";

  export default {
    data() {
      return {
        ENV_TYPE_LARK_MINI_PROGRAM,
        title: '',
        userInfo: null,
        currentCompany: null,
        articleList: [],
        activityList: [],
        version: '1.7.2',
        permission: {},
        applyNum: 0,
        aEle: null
      }
    },
    async created() {
      this.userInfo = this.$store.getters.userInfo
      this.currentCompany = this.$store.getters.company
      this.permission = this.$store.getters.adminInfo

      if (this.$route.params.pageConfigId === '123') {
        this.title =  '我的'
      } else {
        const pageConfig = await this.$store.dispatch('actionSpacePageConfigDetail', {
          spaceId: this.$route.params.spaceId,
          pageConfigId: this.$route.params.pageConfigId
        }).catch(console.error)
        this.title = pageConfig ? pageConfig.pageTitle : '我的'
      }
      this.$store.dispatch('setPageTitle', this.title)

      this.$store.dispatch('actionCompanyWaitHandleMember')
        .then(res => {
          this.applyNum = res.unConfirm
        })
        .catch(console.error)

      this.$store.dispatch('actionFetchActivityList')
        .then(res => {
          this.articleList = res.articleList
          this.activityList = res.activityList
        })
        .catch(console.error)

      this.aEle = document.createElement('a')
    },
    methods: {
      actionPhoneSeparated(tel) {
        return phoneSeparated(tel)
      },
      onClickTempCenter() {
        const toast = this.$toast.loading({message: '加载中...'})
        this.$store.dispatch('reqNodeSave', {
          userId: this.$store.getters.userId,
          userInfo: this.$store.getters.userInfo,
          company: this.$store.getters.company,
          token: this.$store.state.token,
        })
          .then(res => {
            this.$router.push({
              name: 'templateList',
              query: {
                key: res.nodeKey
              }
            })
          })
          .catch(err => {
            console.error(err)
          })
          .finally(() => {
            toast.clear()
          })
      },

      onClickOrder() {
        this.$router.push({
          name: 'orderCenter'
        })
      },

      onClickTeamApply() {
        const toast = this.$toast.loading({message: '加载中...'})
        this.$store.dispatch('reqNodeSave', {
          userId: this.$store.getters.userId,
          companyId: this.$store.getters.currentCompanyId,
          token: this.$store.state.token,
        })
          .then(res => {
            this.$router.push({
              name: 'teamApply',
              query: {
                key: res.nodeKey
              }
            })
          })
          .catch(err => {
            console.error(err)
          })
          .finally(() => {
            toast.clear()
          })
      },

      onclickArticleItem(item) {
        if (!item.jumpUrl) {
          this.$toast.fail('跳转地址不存在')
          return
        }
        if (this.aEle) {
          this.aEle.href = item.jumpUrl
          this.aEle.target = '_blank'
          this.aEle.click()
        }
      },

      // 解除绑定
      onClickRemoveBinding() {
        this.$dialog.confirm({
          title: '提示',
          message: '解除绑定后将无法查看已有数据。是否解除绑定？',
        })
          .then(() => {
            // on confirm
            const toast = this.$toast.loading({
              message: '解除绑定中...'
            })
            this.$store.dispatch('actionSpaceRemoveBinding', {
              formId: this.$store.state.formId,
              instanceIdList: [this.instanceId]
            }).then(() => {
              this.$toast.success('解除绑定成功')
              // 清除登录信息
              setCookie('home3rd_login', '', 365)
              window.localStorage.clear()
              window.sessionStorage.clear()

              // 退出webview
              if (window.isWexin || window.isWxWork) {
                window.WeixinJSBridge.call('closeWindow')
              } else {
                location.replace(`${location.origin}${this.$BASE_PATH}/home3rd/open?portal_id=${this.$route.params.spaceId}`)
              }
            }).catch(err => {
              console.error(err)
            }).finally(() => {
              toast.clear()
            })
          })
          .catch(() => {
            // on cancel
          });
      },

      // 退出
      onClickLogout() {
        this.$dialog.confirm({
          title: '提示',
          message: '是否确定退出？',
        })
          .then(() => {
            // on confirm
            this.$toast.success('退出成功')

            // 清除登录信息
            setCookie('home3rd_login', '', 365)
            window.localStorage.clear()
            window.sessionStorage.clear()

            // 退出webview
            if (window.isWexin || window.isWxWork) {
              window.WeixinJSBridge.call('closeWindow')
            } else {
              location.replace(`${location.origin}${this.$BASE_PATH}/home3rd/open?portal_id=${this.$route.params.spaceId}`)
            }
          })
          .catch(() => {
            // on cancel
          });
      }
    }
  }
</script>

<style lang="less">

  .mine-container {
    height: 100%;
    overflow: auto;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;

    .mine-header {
      height: 80px;
      width: 100%;
      border-bottom: 1px solid #ebedf0;
      background-color: #FFFFFF;
      margin-bottom: 10px;
      display: flex;
      padding: 18px 20px 18px 0;
      align-items: center;
      box-sizing: border-box;
    }

    .mine-header__user-image {
      margin-left: 16px;
      margin-right: 12px;
      border-radius: 6px;
    }

    .mine-header__user-info {
      flex: 1;
      justify-items: center;
      display: flex;
      flex-direction: column;
      margin-left: 10px;
    }

    .user-info__nick-name {
      font-size: 18px;
      color: #282828;
      line-height: 32px;
      font-weight: bold;
    }

    .user-info__account {
      font-size: 14px;
      color: #656565;
      line-height: 26px;
    }

    .mine-body__company-select {
      margin-bottom: 10px;
    }

    .mine-body__company-handler {
      width: 100%;
      margin-bottom: 10px;
      height: 140px;
      background-color: #FFFFFF;
    }

    .company-handler__title {
      font-size: 14px;
      color: #323233;
      margin-left: 10px;
      background-color: #FFFFFF;
      padding-top: 10px;
    }

    .company-handler__image-container {
      width: 100%;
      margin-top: 12px;
      display: flex;
      justify-content: space-around;
      background-color: #FFFFFF;
    }

    .van-popup.van-popup--center.van-popup--safe {
      background-color: transparent;
    }

    .footer-button-container {
      display: flex;
      justify-content: space-around;
      margin-top: 15px;
    }

    .activity-image-container {
      width: 100%;
      background-color: transparent;
      margin: 10px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .activity-image-item {
      width: 90%;
      height: 100px;
      background-color: transparent;
      border-radius: 5px;
      margin-bottom: 10px;
    }

    .active-company {
      display: flex;
      justify-content: flex-end;
    }

    .van-tag {
      margin-right: 10px;
    }

    .version {
      position: fixed;
      color: #969799;
      height: 30px;
      line-height: 30px;
      font-size: 14px;
      bottom: calc(10px + env(safe-area-inset-bottom));
      left: 0;
      right: 0;
      text-align: center;
    }

    .van-cell {
      justify-content: space-between;
    }

    .van-cell__title {
      width: calc(100% - 30px);
      flex: none !important;
      -webkit-flex: none !important;
    }

    .company-cell {
      .van-cell__title {
        width: auto;
      }
    }

    .van-cell-text {
      /*flex: 1;*/
      max-width: calc(100% - 50px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .subscribe-cell .van-cell__title {
      width: 300px;
    }

    .company-list-item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      text-align: center;
      height: 50px;
      padding: 0;
      line-height: 50px;
      font-size: 16px;
      background-color: #fff;
      border-bottom: 1px solid #ebedf0;
    }

    .company-name {
      max-width: 70%;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .ext-tip {
      display: inline-block;
      line-height: 50px;
      font-size: 12px;
      color: darkgray;

    }
  }
</style>
